function slugify(value = "") {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function normalizeFooterHeadingsResponse(response) {
  const root = response?.data ?? response ?? {};
  const headings = Array.isArray(root.footerHeadings) ? root.footerHeadings : [];

  return headings
    .map((section, index) => {
      const links = (Array.isArray(section?.data) ? section.data : [])
        .filter((item) => item?.title && item?.link)
        .map((item) => ({
          label: item.title,
          href: item.link,
        }));

      return {
        id: String(section?.id || slugify(section?.title) || index),
        title: section?.title || "",
        links,
      };
    })
    .filter((section) => section.title && section.links.length > 0);
}
